<template>
  <div id="compreSportsMeet_schedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        v-if="selectOptData"
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
        :manualRefresh="selectOpt_manualRefresh"
      ></marathon_select_opt>
    </div>
    <template v-if="themeItem && matchList && matchList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
        :changeOptions="multipleChoiceShareFixedBtn_changeOptions"
        @changeTypeEvent="multipleChoiceShareFixedBtn_changeTypeEventHandler"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div
      class="teamTable"
      :class="
        multipleChoiceShareFixedBtn_model === 'circular'
          ? 'multipleChoiceShare_fixedBtn_isCircular'
          : ''
      "
    >
      <div class="tableScrollArea" ref="tableParentDom">
        <div
          class="match_label_fixed"
          v-if="curMatchLabelFixedIcon && currBigSports"
        >
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon">
                <img
                  :src="
                    currSid === 'ASG2026'
                    ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${currBigSports.icon}.png`
                    : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`"
                />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <schedule_group_matchList
            v-for="item in matchList"
            :currCid="currCid"
            :currSid="currSid"
            :key="item.icon"
            :currThemeObj="currThemeObj"
            :data="item"
            :pbPx="matchItemPbpx"
          >
            <template v-slot:matchList>
              <schedule_match_list
                :currCid="currCid"
                :currSid="currSid"
                :currThemeObj="currThemeObj"
                :data="item.list"
                :detailPathName="'CSMeetSportDetailScheduleDetailDataAnalysis'"
                :chooseState="multipleChoiceShareFixedBtn_state"
                :localStorageName="
                  multipleChoiceShareFixedBtn_modeType &&
                  multipleChoiceShareFixedBtn_modeType.localStorageName
                    ? multipleChoiceShareFixedBtn_modeType.localStorageName
                    : ''
                "
                :localStorageSaveDate="currStageMatchDate"
                @changeChooseNumEvent="changeChooseNumEventHandler"
                :viewMode="currScheduleMatchList_viewMode"
                :matchModeObj="scheduleMatchList_matchMode"
                @clickMatchItemCheckboxItemEvent="
                  clickMatchItemCheckboxItemEventHandler
                "
                :channelType="currScheduleMatchList_channelType"
              />
            </template>
          </schedule_group_matchList>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="clickSmallBtnEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
      :commitBeforeCheckoutCallback="
        multipleChoiceShare_commitBeforeCheckoutCallback
      "
    >
      <template v-slot:checkList>
        <schedule_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="currStageMatchDate"
          @changeChooseNumEvent="changeChooseNumEventHandler"
          :viewMode="currScheduleMatchList_viewMode"
          :matchModeObj="scheduleMatchList_matchMode"
          @clickMatchItemCheckboxItemEvent="
            clickMatchItemCheckboxItemEventHandler
          "
          :channelType="currScheduleMatchList_channelType"
        />
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
import {
  https_schedule_matchList,
  https_sportsList,
  https_select_dateBigSports,
  https_select_delegationList,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'compreSportsMeet_schedule',
  components: {
    marathon_select_opt,
    schedule_group_matchList,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    schedule_match_list,
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入比赛名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      scheduleMatchList_matchMode: {
        mode: 'compreSportsMeet',
        type: '',
        filterCondition: '',
      },
      currStageMatchDate: '',
      currStageBigSports: '',
      currStageDelegation: '',
      curInputVal: '',
      pnum: 1,
      psize: 20,
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      matchDateArr: [],
      bigSportsArr: [],
      delegationArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            dataName: 'matchDateArr',
            selectIndex: 0,
          },
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true, //选择框是否带可搜索功能
          },
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      showBackTop: false,
      themeTemplateType: 15,
      currScheduleMatchList_viewMode: '',
      currScheduleMatchList_channelType: 'radio',
      channelTv_changeOptions_index: -1, //赛程预告主题的索引位置
      matchListViewMode: [
        'scheduleCSMeet',
        'detailDataCSMeet',
        'scheduleNoticeCSMeet', //'预告'
      ], //这里的字符串相等于唯一id，不能一样，因为判断时用到了indexOf()
      multipleChoiceShareFixedBtn_modeType: null,
      multipleChoiceShareFixedBtn_changeOptions: [],
      // multipleChoiceShareFixedBtn_modeType: {
      //   btnName: '创建赛程',
      //   type: 'schedule',
      //   localStorageName: 'mixtmt_choose_scheduleCSMeet',
      //   unit: '场',
      // },
      // multipleChoiceShareFixedBtn_changeOptions: [
      //   {
      //     btnName: '创建赛程',
      //     shortName: '赛程',
      //     type: 'scheduleCSMeet',
      //   },
      //   {
      //     btnName: '创建成绩',
      //     shortName: '成绩',
      //     type: 'detailDataCSMeet',
      //   },
      // ],
    }
  },
  created() {
    this.initPbPx()
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    currBigSports() {
      let label = ''
      this.bigSportsList.forEach((item) => {
        if (item.id === this.curMatchLabelFixedIcon) {
          label = item.CN
        }
      })
      return {
        label: label,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    curMatchListNum() {
      let curMatchListNum = 0
      if (this.matchList && this.matchList.length > 0) {
        this.matchList.forEach((group) => {
          curMatchListNum +=
            group.list && group.list.length ? group.list.length : 0
        })
      } else {
        curMatchListNum = 0
      }
      console.debug('curMatchListNum:', curMatchListNum)
      return curMatchListNum
    },
    noMore() {
      console.debug(
        'noMore:',
        this.curMatchListNum,
        this.matchTotal,
        this.isScrollBottom
      )
      return this.curMatchListNum >= this.matchTotal && this.matchTotal !== 0
    },
    noData() {
      return (
        this.matchTotal === 0 && this.matchList && this.curMatchListNum === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      console.debug(
        'this.currGroup1:',
        this.currGroup,
        this.currThemeObj,
        this.currCid
      )
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        await this.initFindanalysisItem()
      }
      this.initMatchListQuery()
      console.debug(this.currCid, this.currSid)
      await this.getBigSportsList()
      await this.getStageDateSports()
      await this.getDelegationList()
      await this.getScheduleMatchList()
      if (this.matchDateArr.length > 0) {
        if (this.delegationArr.length > 1) {
          // 初始化，默认选第二个代表团，要修改 selectIndex 的默认值
          if (this.currCid !== 'NSG') {
            this.selectOptData.configArr[2].selectIndex = 1
          }
        }
        this.computedSelectOpt(this.selectOptData.configArr)
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async selectOpt_manualRefresh() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleMatchList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.initMatchListQuery()
      this.getScheduleMatchList()
    },
    markChanleTv2MatchItem(channelTv_changeOptions_index) {
      // 初始化 matchList 数据，将主题中的频道下拉框数据赋值比赛中
      console.debug(
        'channelTv_changeOptions_index:',
        channelTv_changeOptions_index,
        this.inFilter_channelTvObj
      )
      if (channelTv_changeOptions_index === -1 || !this.inFilter_channelTvObj)
        return
      const channelTv_localStorageName = `mixtmt_choose_${this.matchListViewMode[channelTv_changeOptions_index]}` // 频道主题缓存中的名字
      const chooseObj = this.getLocalStorageChooseObj(
        channelTv_localStorageName
      )
      console.debug('chooseObj:', chooseObj, channelTv_localStorageName)
      if (
        chooseObj &&
        chooseObj.chooseItemArr &&
        chooseObj.chooseItemArr.length > 0
      ) {
        // 判断缓存中的 channelTvList 是否与当前的 channelTvList 一致，如果不一致取新的，如果一致则取缓存
        let isDiffDataFlag = true //缓存中的数据是否与新的数据一致
        let localStorage_channelTvList = chooseObj.chooseItemArr[0]
          .channelTvList
          ? chooseObj.chooseItemArr[0].channelTvList
          : []
        const new_channelTvList = this.inFilter_channelTvObj.values
        if (localStorage_channelTvList.length !== new_channelTvList.length) {
          // 个数比较
          isDiffDataFlag = false
        }
        if (isDiffDataFlag) {
          let diffIdNum = 0 // 相同value的个数
          localStorage_channelTvList.forEach((localChannelItem) => {
            new_channelTvList.forEach((newChannelItem) => {
              if (newChannelItem.value === localChannelItem.value) {
                diffIdNum++
                if (newChannelItem.name !== localChannelItem.name) {
                  isDiffDataFlag = false
                }
              }
            })
          })
          if (isDiffDataFlag) {
            // 个数虽然相同，然后对比2个数组中它们的value是的都一致
            if (diffIdNum !== localStorage_channelTvList.length) {
              isDiffDataFlag = false
            }
          }
        }
        this.isDiffDataFlag = isDiffDataFlag
      }
      const matchList = JSON.parse(JSON.stringify(this.matchList))
      this.matchList = matchList.map((group) => {
        group.list.map((item) => {
          item.channelTvList = JSON.parse(
            JSON.stringify(
              this.inFilter_channelTvObj.values.map((valObj, valIndex) => {
                if (valIndex === 0) {
                  valObj.act = true
                } else {
                  valObj.act = false
                }
                return valObj
              })
            )
          )
          return item
        })
        return group
      })
      console.debug('markChanleTv2MatchItem:', this.matchList)
    },
    multipleChoiceShare_initThemeListCallback(themeList) {
      console.debug('multipleChoiceShare_initThemeListCallback:', themeList)
      // 当获取到主题list数据后，将主题中的数据赋值到其他地方
      let changeOptions = []
      this.channelTv_changeOptions_index = -1 //存储频道主题在multipleChoiceShareFixedBtn_changeOptions中的索引
      this.inFilter_channelTvObj = null //切换赛季时需要重新获取主题列表，判断是否有频道
      if (themeList) {
        themeList.forEach((themeItem, themeIndex) => {
          if (themeItem.graphicsId === 3014) {
            let type = this.matchListViewMode[0]
            changeOptions[themeIndex] = {
              index: themeIndex,
              btnName: themeItem.analysisItemName,
              shortName: '赛程',
              type,
              localStorageName: `mixtmt_choose_${type}`,
              unit: '场',
            }
          } else if (themeItem.graphicsId === 3020) {
            let type = this.matchListViewMode[1]
            changeOptions[themeIndex] = {
              index: themeIndex,
              btnName: themeItem.analysisItemName,
              shortName: '成绩',
              type,
              localStorageName: `mixtmt_choose_${type}`,
              unit: '场',
            }
          } else if (themeItem.graphicsId === 3024) {
            let type = this.matchListViewMode[2]

            changeOptions[themeIndex] = {
              index: themeIndex,
              btnName: themeItem.analysisItemName,
              shortName: '预告',
              type,
              localStorageName: `mixtmt_choose_${type}`,
              unit: '场',
              customkeyArrActJson: {},
            }
            this.channelTv_changeOptions_index = themeIndex
            // 测试需要
            // themeItem.inFilter = themeItem.filter

            this.inFilter_channelTvObj = themeItem.inFilter
              ? themeItem.inFilter.filterTypes[0]
              : null
            if (
              this.inFilter_channelTvObj &&
              this.inFilter_channelTvObj.values
            ) {
              this.inFilter_channelTvObj.values.forEach((channelItem) => {
                channelItem.value = channelItem.value + ''
              })
              // this.inFilter_channelTvObj.name => 'channel'
              changeOptions[themeIndex].customkeyArrActJson['actChannelArr'] = {
                // 频道选择，二维数组，最后从缓存数据中组装数据，放到json中的数据，提交创建主题，this.matchList中的单场比赛不需要这个字段
                type: 'Array', //放到json里面字段值类型是数组
                isOnly: false, //是否去重
                keyArr: [this.inFilter_channelTvObj.name, 'actChannelArr'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
              }
            }
          }
        })
        this.multipleChoiceShareFixedBtn_changeOptions = changeOptions
        this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(0)
      } else {
        this.multipleChoiceShareFixedBtn_changeOptions = []
      }
    },
    multipleChoiceShareFixedBtn_changeScheduleMatchListView(actIndex) {
      this.multipleChoiceShareFixedBtn_modeType =
        this.multipleChoiceShareFixedBtn_changeOptions[actIndex]
      this.currScheduleMatchList_viewMode = this.matchListViewMode[actIndex]
    },
    multipleChoiceShareFixedBtn_changeTypeEventHandler(data) {
      // 切换分享模式走这里
      if (data) {
        let multipleChoiceShareFixedBtn_modeType = null
        if (data.type === 'rect') {
          // 分享赛程切换模式时执行的函数，支持2或大于2个以上的选项切换
          let actIndex =
            data.modeType.index + 1 >=
            this.multipleChoiceShareFixedBtn_changeOptions.length
              ? 0
              : data.modeType.index + 1
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type !== data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        } else if (data.type === 'circular') {
          // 圆型时传来的就是选中的主题
          let actIndex = data.modeType.index
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type === data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        }
        this.isClearlearLocalStorageChoose()
      }
      if (this.themeItem && this.themeItem.graphicsId === 3020) {
        // 暂时先用 graphicsId 做为唯一id，区分使用，因为三个主题的 graphicsId 都不一样，如果一样了要改逻辑
        this.themeItem.actJson.orgId =
          this.currStageDelegation === 'all' ? '' : this.currStageDelegation
      }
      console.debug('this.themeItem:', this.themeItem, this.matchList)
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal,
      //   this.curMatchListNum
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
      // if (scrollTop > 0) {
      //   this.changeMatchLabelFixed(scrollTop, direction)
      // }

      this.scrollChangeHandler(scrollTop)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.load()
          if (this.pnum > this.allPages) {
            this.isScrollBottom = true
          }
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      // this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // console.debug(
      //   'this.parentWidthPx:',
      //   this.$refs.tableParentDom.scrollHeight
      // )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    changeChooseNumEventHandler(data) {
      // 这个是多选分享每个.vue文件根据数据结构，单独写的
      console.debug('isClearlearLocalStorageChoose:', data)
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        // multipleChoiceShare_fixedBtn 组件清除缓存数据时，源数据是否要重置
        this.matchList.forEach((group) => {
          if (group.list) {
            group.list.forEach((match) => {
              match.isChooseFlag = false
              if (
                this.channelTv_changeOptions_index > -1 &&
                data.type ===
                  this.matchListViewMode[this.channelTv_changeOptions_index]
              ) {
                // 频道预告
                if (match.channelTvList) {
                  const channelTvList = JSON.parse(
                    JSON.stringify(match.channelTvList)
                  )
                  channelTvList.forEach((item, itemIndex) => {
                    if (itemIndex === 0) {
                      item.act = true
                    } else {
                      item.act = false
                    }
                  })
                  match.channelTvList = channelTvList
                }
              }
            })
          }
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        console.debug('data.type:', data, chooseSchedule, this.isDiffDataFlag)
        let matchList = JSON.parse(JSON.stringify(this.matchList))
        matchList.forEach((group) => {
          if (group.list) {
            group.list.forEach((item) => {
              if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
                item.isChooseFlag = true
                // 只有多选的才会 data.type
                if (
                  this.channelTv_changeOptions_index > -1 &&
                  data.type ===
                    this.matchListViewMode[this.channelTv_changeOptions_index]
                ) {
                  // 赛程预告
                  chooseSchedule.chooseItemArr.forEach((chooseItem) => {
                    if (chooseItem.chooseId === item.chooseId) {
                      if (this.isDiffDataFlag) {
                        // 数据一致
                        item.channelTvList = chooseItem.channelTvList
                        console.debug('chooseItem:', chooseItem)
                      } else {
                        // 数据不一致，全部保持数据初始化状态
                      }
                    }
                  })
                }
              } else {
                item.isChooseFlag = false
              }
            })
          }
        })
        this.matchList = matchList
        this.$localStorage.setItem(
          data.localStorageName,
          JSON.stringify(chooseSchedule)
        )
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    multipleChoiceShare_commitBeforeCheckoutCallback(
      multipleChoiceShareFixedBtn_modeType
    ) {
      console.debug(
        'multipleChoiceShareFixedBtn_modeType:',
        multipleChoiceShareFixedBtn_modeType
      )
      let isCheckoutFlag = true
      let errorTipText = ''
      let chooseObj = this.getLocalStorageChooseObj(
        multipleChoiceShareFixedBtn_modeType.localStorageName
      )
      if (
        this.channelTv_changeOptions_index > -1 &&
        multipleChoiceShareFixedBtn_modeType.type ===
          this.matchListViewMode[this.channelTv_changeOptions_index]
      ) {
        // 频道预告需要验证
        for (let i = 0; i < this.matchList.length; i++) {
          const groupList = this.matchList[i].list
          for (let j = 0; j < groupList.length; j++) {
            let isActChooce = false // 验证每一场比赛是否都至少选择一个
            const matchItem = groupList[j]
            if (matchItem.isChooseFlag && matchItem.channelTvList) {
              // 比赛被选中且频道数组中没有元素时，不能创建，提示未选择频道
              matchItem.channelTvList.forEach((channelItem) => {
                if (channelItem.act) {
                  isActChooce = true
                }
              })

              if (!isActChooce) {
                // 如果 isActChooce 没有为 true 则证明选中的比赛中有没有选中的频道，所以为 false；因此验证不通过，跳出循环
                isCheckoutFlag = false
                break
              }
            }
          }
        }
        errorTipText = '分享的比赛中存在【未选择频道】的比赛'

        if (isCheckoutFlag) {
          // 验证通过，直接组装缓存数据中的 actChannelArr 数据，创建的时候是从缓存中取数据的
          chooseObj.chooseIdArr.forEach((chooseId) => {
            let actChannelArr = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              if (
                chooseItem.chooseId === chooseId &&
                chooseItem.channelTvList
              ) {
                chooseItem.channelTvList.forEach((channelItem) => {
                  if (channelItem.act) {
                    actChannelArr.push(channelItem.value)
                  }
                })
                chooseItem.actChannelArr = actChannelArr
              }
            })
          })
          this.$localStorage.setItem(
            multipleChoiceShareFixedBtn_modeType.localStorageName,
            JSON.stringify(chooseObj)
          )
        }
      } else if (
        multipleChoiceShareFixedBtn_modeType.type === 'detailDataCSMeet'
      ) {
        // 之前逻辑：今日成绩需要验证是否选中代表团且可以选中多场非对抗类比赛
        // 新的逻辑：支持多次比赛，且支持对抗和非对抗混合分享；因此至少有一场比赛和一个代表团即可分享

        if (
          !(
            this.themeItem &&
            this.themeItem.actJson &&
            this.themeItem.actJson.orgId
          )
        ) {
          errorTipText = '该主题必须选中某一个代表团'
        }
        // if (
        //   !(
        //     chooseObj.chooseItemArr &&
        //     // chooseObj.chooseItemArr.length === 1 &&
        //     chooseObj.chooseItemArr[0].type === this.sportsTypeArr[1]
        //   )
        // ) {
        //   errorTipText = '该主题只能选择非对抗类的比赛'
        // }
        if (!chooseObj.chooseItemArr || chooseObj.chooseItemArr.length === 0) {
          errorTipText = '该主题至少要选择一场比赛'
        }

        if (errorTipText) {
          isCheckoutFlag = false
        }
      }
      // console.debug('this.matchList:', this.matchList)
      console.debug('errorTipText:', errorTipText, this.themeItem, chooseObj)
      return { isCheckoutFlag, errorTipText }
    },
    updateLocalStorageHandler(localStorageName, matchItem, actItem, type) {
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let chooseObj = this.$localStorage.getItem(localStorageName)
        ? JSON.parse(this.$localStorage.getItem(localStorageName))
        : {
            cid: this.currCid,
            // date: this.localStorageSaveDate,
            chooseItemArr: [],
            chooseIdArr: [],
          }
      if (chooseObj.cid === this.currCid) {
        if (chooseObj.chooseItemArr.length === 0) {
          // 因为只是点击频道选择，执行此函数证明，缓存中有数据，所以不会走到这里
          // this.matchList.forEach((matchItem) => {
          //   if (matchItem.isChooseFlag) {
          //     chooseObj.chooseItemArr.push(matchItem)
          //     chooseObj.chooseIdArr.push(matchItem.chooseId)
          //   }
          // })
        } else {
          // 这里是缓存中的数据，已经是被选中的比赛了，所以不用再判断是否被选中了
          if (type) {
            if (type === 'checkbox') {
              // 多选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = !channleItem.act
                    }
                  })
                }
              })
            } else if (type === 'radio') {
              // 单选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = true
                    } else {
                      channleItem.act = false
                    }
                  })
                }
              })
            }
          }
        }
        this.$localStorage.setItem(localStorageName, JSON.stringify(chooseObj))
        this.localStorageChooseList = chooseObj.chooseItemArr
        console.debug('chooseObj:', chooseObj)
      } else {
        console.error('错误：赛事不同')
      }
    },
    clickMatchItemCheckboxItemEventHandler(data) {
      // cba单选， 亚运会可能单选可能多选
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let isUpdateLocalStroge = false
      let { matchItem, actItem, type } = data
      console.debug('clickMatchItemCheckboxItemEventHandler:', type)
      let matchList = JSON.parse(JSON.stringify(this.matchList))
      if (type === 'checkbox') {
        // 多选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              match.channelTvList.forEach((channleItem) => {
                if (channleItem.value === actItem.value) {
                  channleItem.act = !channleItem.act
                }
              })
              if (match.isChooseFlag) {
                isUpdateLocalStroge = true
              }
            }
          })
        })
      } else if (type === 'radio') {
        // 单选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              match.channelTvList.forEach((channleItem) => {
                if (channleItem.value === actItem.value) {
                  channleItem.act = true
                } else {
                  channleItem.act = false
                }
              })
              if (match.isChooseFlag) {
                isUpdateLocalStroge = true
              }
            }
          })
        })
      }
      this.matchList = matchList
      if (isUpdateLocalStroge) {
        // 如果该比赛被选中，则需要将频道数据同步到缓存中，否则不需要同步缓存数据;
        // 由于缓存中可能会存储多天的比赛数据，所以不能再matchList中将被选中的数据替换到缓存中
        this.updateLocalStorageHandler(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
          matchItem,
          actItem,
          this.currScheduleMatchList_channelType
        )
      }
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }

      // console.debug(
      //   'curMatchLabelFixed:',
      //   scrollMatchItemHeightArr,
      //   curMatchLabelFixedIcon,
      //   valPx,
      //   direction
      // )
      if (this.matchTotal > 0) {
        this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
      }
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      this.curHeightPx = curHeightPx
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    onResizeEvent() {
      this.initPbPx()
      // if (this.$refs.tableParentDom) {
      //   this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // } else {
      //   console.debug('dom 不存在')
      // }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'matchDate') {
            // let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.currStageMatchDate = valPathArr[1]
            // let originDateBigSportsArr = this.originDateBigSportsArr
            // originDateBigSportsArr.forEach((item, itemIndex) => {
            //   if (item.value === valPathArr[1]) {
            //     // console.debug('asdadsada:', item, valPathArr)
            //     item.selected = true
            //     this.selectOptData.configArr[0].selectIndex = itemIndex
            //     let bigSportsArr = item.disciplines
            //       ? item.disciplines.map((ceil) => {
            //           return {
            //             value: ceil.disciplineCode,
            //             name: ceil.disciplineName,
            //           }
            //         })
            //       : []

            //     if (bigSportsArr.length > 1) {
            //       this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
            //     } else {
            //       this.bigSportsArr = bigSportsArr
            //     }
            //     this.currStageBigSports = this.bigSportsArr[0].value
            //   } else {
            //     item.selected = false
            //   }
            // })
            // this.originDateBigSportsArr = originDateBigSportsArr
            // this.currStageDelegation = this.delegationArr[0].value
            // this.computedSelectOpt(this.selectOptData.configArr)
            // console.debug(
            //   'bigSports bigSports:',
            //   this.selectOptData,
            //   this.bigSportsArr
            // )
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else if (valPathArr[0] === 'delegation') {
            this.currStageDelegation = valPathArr[1]
            console.debug('detailDataCSMeet:', this.currStageDelegation)
            // 【比赛成绩】主题单独加的，该主题生成数据条件是：1.必须选择代表团；2.只能选择一场非对抗类的比赛
            // 因此每次代表团变化时都在这里复制
            const changeOptions = this.multipleChoiceShareFixedBtn_changeOptions
            if (changeOptions && changeOptions.length > 0) {
              changeOptions.forEach((optItem, optIndex) => {
                if (optItem.type === 'detailDataCSMeet') {
                  // 代表团为全部，也就是空值时，不能分享成功，报错提示
                  this.formatThemeListArr[optIndex].actJson.orgId =
                    this.currStageDelegation === 'all'
                      ? ''
                      : this.currStageDelegation
                }
              })
            }
          } else {
          }
          // 筛选表格逻辑
          this.initMatchListQuery()
          this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      console.debug('load')
      if (this.pnum > this.allPages || this.loading) {
        return
      }
      this.loading = true
      this.getScheduleMatchList()
    },
    initMatchListQuery() {
      this.pnum = 1
    },
    async getStageDateSports() {
      await https_select_dateBigSports(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data

          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            // this.originDateBigSportsArr = res.data.map((item) => {
            //   return {
            //     value: item.date,
            //     name: item.dateFormatter,
            //     disciplines: item.disciplines,
            //     selected: item.selected,
            //   }
            // })
            const matchDateArr = res.data
              ? res.data.map((item, itemIndex) => {
                  if (item.selected) {
                    this.currStageMatchDate = item.date
                    this.selectOptData.configArr[0].selectIndex = itemIndex + 1
                    // let bigSportsArr = item.disciplines
                    //   ? item.disciplines.map((ceil) => {
                    //       return {
                    //         value: ceil.disciplineCode,
                    //         name: ceil.disciplineName,
                    //       }
                    //     })
                    //   : []
                    // if (bigSportsArr.length > 1) {
                    //   this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
                    // } else {
                    //   this.bigSportsArr = bigSportsArr
                    // }
                    // this.currStageBigSports = this.bigSportsArr[0].value
                  }
                  return {
                    value: item.date,
                    name: item.dateFormatter,
                  }
                })
              : []
            this.matchDateArr = [].concat(
              JSON.parse(JSON.stringify(this.selectAllObj)),
              matchDateArr
            )
            console.debug('getStageDateSports:', this.matchDateArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
              let bigSportsArr = res.data
                ? res.data.map((ceil) => {
                    return {
                      value: ceil.disciplineCode,
                      name: ceil.disciplineName,
                    }
                  })
                : []
              let actIndex = 0
              this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
              this.currStageBigSports = this.bigSportsArr[actIndex].value
            } else {
              this.bigSportsApiList = []
              this.currStageBigSports = ''
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getDelegationList() {
      let params = {
        sid: this.currSid,
      }
      await https_select_delegationList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.delegationArr = res.data
              ? [].concat(
                  selectAllObj,
                  res.data.map((item) => {
                    return {
                      value: item.organisationCode,
                      name: item.organisationName,
                    }
                  })
                )
              : []
            let actIndex = 0
            if (this.currCid !== 'NSG' && this.delegationArr.length > 1) {
              actIndex = 1
            }
            this.currStageDelegation = this.delegationArr[actIndex].value
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list, this.pnum)
      let matchLabelArr = this.matchLabelArr
      if (list && list.length > 0) {
        let matchList = this.matchList ? this.matchList : []
        let labelObj = {}
        list.forEach((item) => {
          let curIndex = 0
          let newItem = {}
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
          newItem.isChina = item.cn
          newItem.isGold = item.medalFlag === '1'
          newItem.type = item.confrontation
            ? this.sportsTypeArr[0]
            : this.sportsTypeArr[1]
          newItem.matchId = item.scheduleCode
          newItem.chooseId = item.scheduleCode
          newItem.venueName = item.venueName
          newItem.matchStatus = item.scheduleStatus
          newItem.scheduleStatusName = item.scheduleStatusName
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.scheduleName = item.scheduleName
          newItem.formatDate = item.formatDate
          newItem.formatTime = item.formatTime
          newItem.startDatetimeUtc = item.startDatetimeUtc
          newItem.isChooseFlag = false
          newItem.competitorType = item.competitorType
          newItem.medalist = item.medals
            ? item.medals.map((player, index) => {
                return {
                  playerId: index + 1,
                  mcompetitorType: player.mcompetitorType,
                  playerName: player.competitorName,
                  medalType: player.medalType,
                  delegationName: player.organisationName,
                  delegationLogo: player.organisationLogo,
                }
              })
            : []

          if (newItem.type === this.sportsTypeArr[0]) {
            let homeName = '',
              awayName = ''
            homeName = item.competitor1Name ? item.competitor1Name : '待定'
            awayName = item.competitor2Name ? item.competitor2Name : '待定'

            newItem.homeName = homeName
            newItem.awayName = awayName

            newItem.homeScore = item.competitor1Result
            newItem.awayScore = item.competitor2Result
          }
          newItem.homeLogo = item.organisation1Logo
          newItem.awayLogo = item.organisation2Logo

          if (matchLabelArr && matchLabelArr.length > 0) {
            curIndex = matchLabelArr.indexOf(item.disciplineCode)
          } else {
            matchLabelArr.push(item.disciplineCode)
            labelObj = {
              label: item.disciplineName,
              icon: item.disciplineCode,
              list: [],
            }
          }
          if (curIndex > -1) {
            if (!labelObj.icon || labelObj.icon !== item.disciplineCode) {
              labelObj = matchList[curIndex]
                ? matchList[curIndex]
                : {
                    label: item.disciplineName,
                    icon: item.disciplineCode,
                    list: [],
                  }
            }
          } else {
            matchLabelArr.push(item.disciplineCode)
            console.debug(
              'labelObj:',
              matchList.length,
              labelObj,
              item.disciplineCode
            )
            //结束上一个区域
            if (
              matchList.length > 0 &&
              matchList[matchList.length - 1].icon === labelObj.icon
            ) {
              // 新加载的数据第一批中有上一个组数据，此时是替换
              matchList[matchList.length - 1] = labelObj
            } else {
              // 这层if是为了判断一种情况，比如2页加载完后，第三页是一组新的大项数据，此时逻辑会走到这里，所以需要判断这个labelObj里面的list是否有元素，如果有则push，如果没有则不push一个空的大项标题
              if (labelObj && labelObj.list && labelObj.list.length > 0) {
                // 数组中并没有该区域数据，直接push
                matchList.push(labelObj)
              }
            }
            labelObj = {
              label: item.disciplineName,
              icon: item.disciplineCode,
              list: [],
            }
            console.debug(
              'labelObj end:',
              matchList.length,
              matchList[matchList.length - 1].icon,
              labelObj
            )
          }
          labelObj.list.push(newItem)
        })

        if (labelObj.list.length > 0) {
          let curIndex = matchLabelArr.indexOf(labelObj.icon)
          if (curIndex > -1) {
            // console.debug('labelObj end:', matchList, matchList[curIndex])
            if (
              matchList.length > 0 &&
              matchList[matchList.length - 1].icon === labelObj.icon
            ) {
              // 新加载的数据第一批中有上一个组数据，此时是替换
              matchList[matchList.length - 1] = labelObj
            } else {
              // 数组中并没有该区域数据，直接push
              matchList.push(labelObj)
            }
          } else {
            matchList.push(labelObj)
          }
        }
        this.matchList = JSON.parse(JSON.stringify(matchList))
        this.matchLabelArr = JSON.parse(JSON.stringify(matchLabelArr))
        // console.debug(
        //   'computedMatchList end:',
        //   labelObj,
        //   matchList,
        //   matchLabelArr
        // )
        this.markChanleTv2MatchItem(this.channelTv_changeOptions_index)
        this.isClearlearLocalStorageChoose()
      }
    },
    async getScheduleMatchList() {
      let params = {
        sid: this.currSid,
        date: this.currStageMatchDate ? this.currStageMatchDate : '',
        sportsId: this.currStageBigSports
          ? this.currStageBigSports == 'all'
            ? ''
            : this.currStageBigSports
          : '',
        delegationId: this.currStageDelegation
          ? this.currStageDelegation == 'all'
            ? ''
            : this.currStageDelegation
          : '',
        timeZone: this.curTimeZoneItem.val, // 'beijing',
        name: this.curInputVal,
        pnum: this.pnum,
        psize: this.psize,
      }
      console.debug(params)
      await https_schedule_matchList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.matchTotal = res.data.total
              this.allPages = res.data.maxPage
              if (this.pnum == 1) {
                if (this.scrollAreaDom) {
                  this.scrollAreaDom.scrollTo(0, 0)
                }
                this.matchList = []
                this.matchLabelArr = []
                this.curMatchLabelFixedIcon = null
                this.initScroll()
              }
              this.computedMatchList(res.data.datas)
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.matchTotal,
              this.matchList,
              this.matchList.length,
              this.curMatchListNum
            )
            if (this.matchTotal >= this.curMatchListNum) {
              if (this.matchTotal === 0) {
                this.matchList = []
              } else {
                if (this.pnum !== 1) {
                  this.isScrollBottom = false
                  this.firstPageIsScrollBottom = false
                  this.$nextTick(() => {
                    this.loading = false
                    this.getScheduleMatchListDomHeigt()
                  })
                } else {
                  // 第一页就不够数据的
                  this.$nextTick(() => {
                    this.loading = false
                    this.getScheduleMatchListDomHeigt()
                    if (
                      this.$refs.tableParentDom.offsetHeight >=
                      Math.floor(this.curHeightPx)
                    ) {
                      // this.isScrollBottom = true
                      this.firstPageIsScrollBottom = true
                    }
                    console.debug(
                      'getParentHeightPx:',
                      this.$refs.tableParentDom.offsetHeight,
                      this.curHeightPx,
                      this.isScrollBottom,
                      this.matchTotal,
                      this.curMatchListNum
                    )
                  })
                }
                this.pnum++
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
          // this.isClearlearLocalStorageChoose()
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_schedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    /* &.multipleChoiceShare_fixedBtn_isCircular {
    } */
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
